import * as z from 'zod'

// Top-bracket sentinel shared by federal and state marginal-tax bracket
// schedules. On disk the top-bracket row per group uses `"to": null` (JSON
// can't encode `Infinity`); at parse time the transform lifts it to
// `Infinity`. Downstream bracket-cascade math (`amount <= bracket.to`)
// works identically since any finite income is < Infinity.
export const bracketCeilingSchema = z
  .number()
  .positive()
  .nullable()
  .transform(v => v ?? Infinity)

// Infinity-safe comparator for two bracket ceilings. Naïve `a - b` returns
// NaN for `Infinity - Infinity`, which is undefined-behavior input to
// `Array.prototype.sort`. Well-formed data never has two Infinity rows in
// the same group, but we guard the comparator so a future regression
// can't silently corrupt sort order.
export const compareBracketCeilings = (a: number, b: number): number => {
  if (a === b) return 0
  return a < b ? -1 : 1
}
